<select2
  [data]="data"
  [value]="value"
  [placeholder]="placeholder"
  [disabled]="disabled"
  (update)="onUpdate($event)">
</select2>